// @flow
import { curry, find, propEq } from 'ramda';

const debug = require('debug')('jp:stores:features');

const findBy = curry((propName: string, propValue: any) =>
  find(propEq(propName, propValue))
);
const findFeatureByKey = findBy('key');

export default function isFeatureEnabled(
  features: any,
  featureName: string,
  variant?: string
): boolean {
  const isEnabled = (() => {
    const feature = findFeatureByKey(featureName)(features.features);

    if (!feature) {
      return false;
    }

    let { enabled } = feature;
    if (variant) {
      enabled = enabled && feature.variantKey === variant;
    }
    return enabled;
  })();

  debug('isFeatureEnabled?', featureName, isEnabled);
  return isEnabled;
}
